import React from 'react';

const Logo = (props) => {
  return (
    <>
      <h1 className="my-4" style={{color: "white"}}>Demo Brand</h1>
    </>
  );
};

export default Logo;
